/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { gql } from '@apollo/client';

export const GetSouscriptionCustomerGranteesQuery = gql`
  query GetSouscriptionCustomerGranteesQuery {
    getSouscriptionCustomerGrantees_souscription_customer_grantees {
      offerEffectDate 
      offerCode 
      customer {
 firstName  
lastName  
birthDate  
birthCity  
birthCountry  
birthZipCode  
birthName  
socialSecurities {
 number  
isTeletransmission  
organismCode  
twinsRank  
regime  
isCSS  
dateCSS  
} 
isTNS  
isMadelin  
madelinMonth  
isDigitalContract  
civility  
maritalStatus  
sendMode  
CSPs {
 label  
externalId  
categoryCSPExternalId  
categoryLvl1CSPExternalId  
} 
emails {
 value  
type  
} 
phones {
 internationalCode  
number  
isMobile  
} 
addresses {
 fields  
city  
zipCode  
} 
finances {
 annualIncome  
} 
professionalStatus  
amls {
 isPoliticallyExposed  
} 
}
      grantees {
 type  
birthDate  
civility  
firstName  
lastName  
birthName  
socialSecurities {
 number  
isTeletransmission  
organismCode  
twinsRank  
regime  
isCSS  
dateCSS  
} 
granteeId  
CSPs {
 label  
externalId  
categoryCSPExternalId  
categoryLvl1CSPExternalId  
} 
isTNS  
attachedSocialSecurities {
 type  
birthDate  
civility  
firstName  
lastName  
number  
} 
}
      markups {
 markupCode  
level  
}
      consents {
 consentCode  
level  
}
      madelinMonths {
 value  
label  
}
      minBirthDateReducChild 
      maxBirthDateReducChild 
      minBirthDateHospiChild 
      maxBirthDateHospiChild 
      jobs {
 caisse  
label  
value  
}
      beclmBlocked 
      cfeContributionsPaidByRepresentative 
      groupCodes 
      defaultGroupCode 
      company {
 creationDate  
}
    }
  }
`;

export default GetSouscriptionCustomerGranteesQuery;
